import { render, staticRenderFns } from "./SentenciasFirmar.vue?vue&type=template&id=1996804e&scoped=true&"
import script from "./SentenciasFirmar.vue?vue&type=script&lang=js&"
export * from "./SentenciasFirmar.vue?vue&type=script&lang=js&"
import style0 from "./SentenciasFirmar.vue?vue&type=style&index=0&id=1996804e&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1996804e",
  null
  
)

export default component.exports